import React, { useState, useCallback } from "react";
import { useT } from "@transifex/react";
import { RendererProps } from "./index";
import { TextInput } from "./renderer-styles";
import { formatPhone } from "../../../helpers";

const PHONE_VALID = /^(\+\d{1,3}\s?)?\(\d{3}\) \d{3}-\d{4}$/;

const PhoneInputRenderer: React.FC<RendererProps> = ({
  question,
  answer,
  onAnswer,
}) => {
  const t = useT();
  const [value, setValue] = useState<string>(() => {
    const raw = answer?.value ?? "";
    return formatPhone(raw) ?? raw;
  });

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const formatted = formatPhone(e.target.value) ?? e.target.value;
      setValue(formatted);
      const stripped = formatted.replace(/\D/g, "");
      const isValid =
        stripped.length === 0
          ? !question.required
          : PHONE_VALID.test(formatted);
      onAnswer(formatted, isValid, [{ value: formatted }]);
    },
    [onAnswer, question.required]
  );

  return (
    <TextInput
      type="tel"
      value={value}
      onChange={handleChange}
      placeholder={question.placeholder || t("(555) 555-5555")}
    />
  );
};

export default PhoneInputRenderer;
